/**
 * UIIconTimerType enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file UIIconTimerType.ts
 */
export enum UIIconTimerType {
  ITEM_LOST = 0,
  ITEM_RECEIVED = 1,
  CREDITS_RECEIVED = 2,
  JOURNAL_ENTRY_ADDED = 3,
  LIGHT_SHIFT = 4,
  DARK_SHIFT = 5,
  PLOT_XP_RECEIVED = 6,
  STEALTH_XP_RECEIVED = 7,
}